import React from 'react';

import HtmlReport from '../programacoes_plano/HtmlReport';
import Header from '../../common/relatorio/header';
import Footer from '../../common/relatorio/footer';

import {
  getPlanosControlador,
  informacoesPlano,
  trocaPlanos as fetchTrocaPlanos,
  infoControladorAggregadoPorNumero,
} from './generateControladorReportActions';

import UserLocal from '../../configuracao/userLocal';
import { getFaseList } from '../../controlador/controladorActions';
import ReactDOMServer from 'react-dom/server';

async function montarSegurancaPorAnel(ctrlApiData, aneisLista) {
  const resultado = {};
  const aneis = Array.isArray(aneisLista) && aneisLista.length > 0 ? aneisLista : [1, 2, 3, 4];

  const ctrl = Array.isArray(ctrlApiData) && ctrlApiData.length ? ctrlApiData[0] : ctrlApiData;
  if (!ctrl || !Array.isArray(ctrl.aneis)) {
    aneis.forEach(n => {
      resultado[n] = { fases: [], infoConflito: null, faseIni: null, faseFin: null, semCadastro: true };
    });
    return resultado;
  }

  const porNumero = {};
  ctrl.aneis.forEach(a => {
    const n = parseInt(a.anel, 10);
    if (Number.isFinite(n)) porNumero[n] = a;
  });

  const tarefas = aneis.map(async numAnel => {
    const anelRow = porNumero[numAnel];
    if (!anelRow || !anelRow.id) {
      return [numAnel, { fases: [], infoConflito: null, faseIni: null, faseFin: null, semCadastro: true }];
    }
    const fIni = anelRow.numero_fases;
    const fFim = anelRow.numero_fases_fim;
    const fr = await getFaseList(anelRow.id, fIni, fFim);
    const list = (fr.payload && fr.payload.data) || [];
    return [
      numAnel,
      {
        fases: list,
        infoConflito: anelRow,
        faseIni: fIni,
        faseFin: fFim,
        semCadastro: false,
      },
    ];
  });

  const pares = await Promise.all(tarefas);
  pares.forEach(([numAnel, dados]) => {
    resultado[numAnel] = dados;
  });
  return resultado;
}

function HtmlContent(
  controlador,
  planos,
  troca_planos,
  fases,
  info_fases_conflitantes,
  seguranca_por_anel,
  aneis_seguranca_relatorio,
) {
  return ReactDOMServer.renderToString(
    <HtmlReport
      controlador={controlador}
      planos={planos}
      troca_planos={troca_planos}
      fases={fases}
      info_fases_conflitantes={info_fases_conflitantes}
      seguranca_por_anel={seguranca_por_anel}
      aneis_seguranca_relatorio={aneis_seguranca_relatorio}
    />,
  );
}

function FooterReport(name) {
  return ReactDOMServer.renderToString(<Footer name={name} />);
}

function HeaderReport() {
  const title = 'Relatório do Controlador';
  return ReactDOMServer.renderToString(<Header title={title} />);
}

export const generateControladorReport = async (controladorData, selectedAneis, allPlanosList) => {
  const numControlador = controladorData.numero_controlador;
  const grupoFisico = controladorData.grupo_fisico_id;

  let planosList = allPlanosList;
  if (!planosList) {
    const r = await getPlanosControlador(numControlador, grupoFisico);
    planosList = r.data || [];
  }

  const filteredPlanos =
    selectedAneis && selectedAneis.length > 0
      ? planosList.filter(p => selectedAneis.includes(p.anel))
      : planosList;

  if (filteredPlanos.length === 0) {
    throw new Error('Nenhum plano nos anéis selecionados.');
  }

  const anelGroups = {};
  filteredPlanos.forEach(p => {
    const an = p.anel;
    if (!anelGroups[an]) anelGroups[an] = [];
    anelGroups[an].push(p);
  });
  const anelNums = Object.keys(anelGroups)
    .map(Number)
    .sort((a, b) => a - b);
  anelNums.forEach(anel => {
    anelGroups[anel].sort((a, b) => a.id - b.id);
  });

  const uniquePlanoIds = [...new Set(filteredPlanos.map(p => p.id))].sort((a, b) => a - b);

  const allPlanosData = [];

  const allBatchResults = [];
  for (const anel of anelNums) {
    const entries = anelGroups[anel];
    const batchResults = await Promise.all(
      entries.map(p => informacoesPlano(p.controlador_id, grupoFisico, p.id).catch(() => null)),
    );
    allBatchResults.push(...batchResults);
  }

  allBatchResults.forEach(result => {
    if (result && result.data && result.data.length > 0) {
      allPlanosData.push(...result.data);
    }
  });

  if (allPlanosData.length === 0) {
    throw new Error('Não foi possível obter informações dos planos deste controlador.');
  }

  const planoById = {};
  filteredPlanos.forEach(p => {
    if (!planoById[p.id]) planoById[p.id] = [];
    planoById[p.id].push(p);
  });

  const anel1Planos = uniquePlanoIds.map(id => {
    const group = planoById[id] || [];
    return group.find(p => p.anel === 1) || group[0];
  }).filter(Boolean);
  let trocaPlanosData = [];
  const trocaResults = await Promise.all(
    anel1Planos.map(p => fetchTrocaPlanos(p.controlador_id, p.id).catch(() => null)),
  );
  trocaResults.forEach(tp => {
    if (tp && tp.data && tp.data.length > 0) {
      trocaPlanosData = [...trocaPlanosData, ...tp.data];
    }
  });

  const aneisParaPdfSeguranca =
    selectedAneis && selectedAneis.length > 0
      ? [...new Set(selectedAneis.map(a => parseInt(a, 10)))].filter(Number.isFinite).sort((x, y) => x - y)
      : [1, 2, 3, 4];

  const ctrlAggregado = await infoControladorAggregadoPorNumero(numControlador, grupoFisico);
  const segurancaPorAnel = await montarSegurancaPorAnel(ctrlAggregado.data, aneisParaPdfSeguranca);

  const htmlReport = HtmlContent(
    controladorData,
    allPlanosData,
    trocaPlanosData,
    [],
    ctrlAggregado.data,
    segurancaPorAnel,
    aneisParaPdfSeguranca,
  );
  const htmlHeader = HeaderReport();
  const htmlFooter = FooterReport(UserLocal.getUserConfig('name'));

  return `
    <html>
      <head>
        <style>
          .report-primeira-pagina-plano-seguranca {
            page-break-after: always;
            break-after: page;
          }
          .report-corpo-diagramas-planos {
            margin-top: 48px;
            padding-top: 8px;
          }
          .diagrama-plano-bloco {
            page-break-inside: avoid;
            break-inside: avoid;
          }
          .container-planos {
            margin-top: 60px;
            margin-bottom: 40px;
            padding: 20px;
          }
          .container-planos-primeira-pagina {
            margin-bottom: 24px;
          }
          .planos-other-div {
            margin-top: 60px;
            margin-bottom: 40px;
            padding: 20px;
          }
          .container-content {
            margin-top: 60px;
            margin-bottom: 40px;
            padding: 20px;
          }
          .tabela-troca-plano {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        </style>
      </head>
      ${htmlHeader}
      ${htmlReport}
      ${htmlFooter}
    </html>
  `;
};
